<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px; width: 94%;">
            <div class=" main-heading">
                <h1>Field Reviews Dashboard</h1>
            </div>

            <div class="card">
                <p-table #reviewdata [value]="filteredFieldReviewData" [tableStyle]="{'min-width': '60rem'}"
                    [paginator]="true" [rows]="10" [showCurrentPageReport]="true" paginatorPosition="both"
                    [scrollable]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 50, 100]" [loading]="loading"
                    [globalFilterFields]="['user_mail', 'comment', 'reviewer_email', 'field', 'section', 'nda_number', 'brand_name', 'active_ingredient', 'route_of_administration', 'dosage_forms', 'submitted_at', 'review_status']">
                    >
                    <ng-template pTemplate="caption">
                        <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">
                            <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus"
                                (onChange)="onFilterChange()" placeholder="Select Status">
                            </p-dropdown>

                            <div class="form-group">
                                <label for="assigneeEmail" style="margin-right: 5px;">Assignee Email </label>
                                <p-dropdown id="assigneeEmail" [options]="userEmailOptions"
                                    [(ngModel)]="selectedUserEmail" (onChange)="onFilterChange()"
                                    placeholder="Select User Email">
                                </p-dropdown>
                            </div>

                            <div class="form-group">
                                <label for="reviewerEmail" style="margin-right: 5px;">Reviewer Email </label>
                                <p-dropdown id="reviewerEmail" [options]="reviewerEmailOptions"
                                    [(ngModel)]="selectedReviewerEmail" (onChange)="onFilterChange()"
                                    placeholder="Select Reviewer Email">
                                </p-dropdown>
                            </div>

                            <span class="p-input-icon-left ml-auto">
                                <input pInputText type="text"
                                    (input)="reviewdata.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Search" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th>User Email</th>
                            <th>Comment</th>
                            <th>Reviewer Email</th>
                            <th>Field</th>
                            <th>Section</th>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>ROA</th>
                            <th>Dosage forms</th>
                            <th>Submitted At</th>
                            <th>Review Status</th>
                            <th>Action</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-data>
                        <tr>
                            <td>{{ data.user_mail }}</td>
                            <td>{{ data.comment }}</td>
                            <td>{{ data.reviewer_email }}</td>
                            <td>{{ data.field }}</td>
                            <td>{{ data.section }}</td>
                            <td>{{ data.nda_number }}</td>
                            <td>{{ data.brand_name }}</td>
                            <td>{{ data.active_ingredient }}</td>
                            <td>{{ data.route_of_administration }}</td>
                            <td>{{ data.dosage_forms }}</td>
                            <td>{{ data.submitted_at }}</td>
                            <td>{{ data.review_status ? 'Reviewed' : 'Pending' }}</td>
                            <td>
                                <button pButton class="p-button-success p-button-sm" (click)="markAsReviewed(data)"
                                    [disabled]="data.review_status === true"
                                    [ngStyle]="{ 'cursor': data.review_status === true ? 'not-allowed' : 'pointer' }"
                                    style="margin-right: 10px; padding: 5px 10px; border-radius: 5px;">
                                    <i class="fas fa-check"></i>
                                </button>
                            </td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="empty">
                        <tr>
                            <td colspan="9" class="text-center">No Data Found</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>